import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type HoverStoreType = {
  /** Id of the entity currently hovered on either surface (list or canvas). */
  hoveredId: string | null;
  /** Id of the entity whose context menu is open; stays highlighted like a hover. */
  pinnedId: string | null;
  setHovered: (id: string | null) => void;
  setPinned: (id: string | null) => void;
  unpin: (id: string) => void;
  clear: () => void;
};

const useHover = create<HoverStoreType>((set, get) => ({
  hoveredId: null,
  pinnedId: null,

  setHovered: (id: string | null) => {
    if (get().hoveredId === id) return;
    set({ hoveredId: id });
  },

  setPinned: (id: string | null) => {
    if (get().pinnedId === id) return;
    set({ pinnedId: id });
  },

  unpin: (id: string) => {
    if (get().pinnedId !== id) return;
    set({ pinnedId: null });
  },

  clear: () => {
    if (get().hoveredId === null) return;
    set({ hoveredId: null });
  },
}));

export const useIsNodeHovered = (id: string) =>
  useHover((state) => state.hoveredId === id || state.pinnedId === id);

export const useHoverActions = () =>
  useHover(
    useShallow((state) => ({
      setHovered: state.setHovered,
      setPinned: state.setPinned,
      unpin: state.unpin,
      clear: state.clear,
    })),
  );

export const { getState: getHoverState, setState: setHoverState } = useHover;

export default useHover;
